import React, { useEffect, useRef, useState } from 'react'
import { stripTags } from '../../models/Common'
import Conditional from '../common/Conditional'
import WorkplaceQuizProgressbarRow from './WorkplaceQuizProgressbarRow'

export interface IWorkplaceQuizProgressbarProps {
  title: string
  current: number
  total: number
  showNumber: boolean
}

const WorkplaceQuizProgressbar = (props: IWorkplaceQuizProgressbarProps) => {
  const mountedRef = useRef(false)
  const [bar, setBar] = useState([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      let index = 0
      const data: number[] = []
      while (index < props.total) {
        data.push(index)
        index++
      }
      setBar(data)
      setIsLoading(false)
    }

    return () => {
      mountedRef.current = false
    }
  }, [props.current])

  return (
    <Conditional if={!isLoading && bar}>
      <div className="progressArea">
        <h3>
          <span>{stripTags(props.title)}</span>
        </h3>
        <ul className="progressBar">
          {bar?.map((item, index) => {
            return (
              <WorkplaceQuizProgressbarRow
                key={index}
                index={item}
                finished={props.current < index}
                currentPoint={props.current === index}
                cssWidth={100 / bar.length}
              />
            )
          })}
        </ul>
      </div>
      <Conditional if={props.showNumber}>
        <span className="moduleIndex">{props.current + 1}</span>
      </Conditional>
    </Conditional>
  )
}

export default WorkplaceQuizProgressbar
